import React, { FC } from 'react';
import PropTypes from 'prop-types';
import WorkshopRegistrationButton from '../../../../workshops/components/WorkshopRegistrationButton';
import { SeeMoreButton } from './SeeMoreButton';
import { ReplayModalButton } from './ReplayModalButton';
import { WorkshopLiveButton } from './WorkshopLiveButton';
import { SeeMoreLiveButton } from './SeeMoreLiveButton';
import { EventStatusButton } from './EventStatusButton';
import { WorkshopAction } from './action.type';
import { SessionsButton } from './SessionsButton';
import { AddToCalendarButtons } from './AddToCalendarButtons';
import { SessionsReplayButton } from './SessionsReplayButton';
import { UnregisterButton } from './UnregisterButton';

const actionButtons: Record<string, React.FC<any>> = {
  'registration': WorkshopRegistrationButton,
  'event-status': EventStatusButton,
  'see-more': SeeMoreButton,
  'replay': ReplayModalButton,
  'workshop-live': WorkshopLiveButton,
  'see-more-live': SeeMoreLiveButton,
  'sessions': SessionsButton,
  'add-to-calendar': AddToCalendarButtons,
  'replay-sessions': SessionsReplayButton,
  'unregister': UnregisterButton,
};

type WorkshopActionsProps = {
  workshop: any;
  actions?: WorkshopAction[];
  itemProps?: any;
  style?: any;
};

const WorkshopActions: FC<WorkshopActionsProps> = (props) => {
  const { workshop, actions = [], itemProps, style } = props;

  if (!actions.length) {
    return null;
  }

  return (
    <div className="actions" style={style}>
      {actions.map(({ _id, type, ...rest }) => {
        const Component = actionButtons[type];
        return <Component key={_id} workshop={workshop} itemProps={itemProps} {...rest} />;
      })}
    </div>
  );
};

WorkshopActions.defaultProps = {
  actions: [],
  itemProps: {},
  style: undefined,
};

WorkshopActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.any.isRequired),
  workshop: PropTypes.object.isRequired,
  itemProps: PropTypes.object,
  style: PropTypes.object,
};

export { WorkshopActions };
